module.exports = "## Bulk image compression\r\n\r\nWant to compress all your images at once? No problem. Simply drag and drop or select your images to our bulk image compressor and it will automatically start compressing them."


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoCompress/photo-compress-section-four.md
// module id = 1158
// module chunks = 0